module.exports = __webpack_public_path__ + "resource/img/dots-menu.2f591fe0.svg";